import styled from '@emotion/styled'
import { ChevronRight } from 'app/components/Icons'
import { HeaderContext } from 'app/containers/Header'
import { styles } from 'app/theme'
import { motion } from 'framer-motion'
import React, { memo, useContext } from 'react'

export interface Props {
  modalStatus?: boolean
}

export const Benefits = memo(function Benefits({ modalStatus }: Props) {
  const { benefits } = useContext(HeaderContext) as any

  if (!benefits) {
    return null
  }

  const variants = {
    visible: (d: any) => ({
      opacity: 1,
      rotate: 0.02,
      y: 0,
      transition: {
        bounce: 0,
        delay: d,
        duration: 1.6,
        type: 'spring',
      },
    }),
    hidden: {
      opacity: 0,
      rotate: 0,
      y: 90,
      transition: {
        delay: 1,
      },
    },
  }

  return (
    <Container className={modalStatus ? 'open' : undefined}>
      {benefits.title ? (
        <Title
          animate={modalStatus ? 'visible' : 'hidden'}
          custom={0.4}
          initial="hidden"
          variants={variants}
        >
          {benefits.title}
        </Title>
      ) : null}

      <List>
        {benefits.list.map((item: any, index: any) => {
          if (!item) return

          return (
            <Item
              initial="hidden"
              animate={modalStatus ? 'visible' : 'hidden'}
              custom={index * 0.15 + 0.8}
              variants={variants}
              key={index}
            >
              <ChevronRight />

              {item.title}
            </Item>
          )
        })}
      </List>
    </Container>
  )
})

const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.variants.neutralLight4};
  opacity: 0;
  padding: 2rem 5vw;
  position: relative;
  transform: translateY(3.75rem);
  transition: 0.6s 0.3s ease-in-out;
  &.open {
    opacity: 1;
    transform: none;
  }
`

const Title = styled(motion.div)`
  ${styles.label}

  margin-bottom: 1.5rem;
`

const List = styled.div``

const Item = styled(motion.div)`
  ${styles.description}

  margin-top: 9px;
  &:first-of-type {
    margin-top: 0;
  }

  svg {
    width: auto;
    height: 0.5rem;
    fill: ${({ theme }) => theme.colors.variants.primaryDark};
    margin-right: 0.75rem;
    transform: translateY(-0.0625rem);
  }
`
